<section arial-label="Progress Bar" class="sections-container">
  @if (!haveSections) {
    <h3 class="white">No Sections to Display</h3>
  } @else {
    @if (showExpediteMessage) {
      <div class="expediteRow expediteMessage">
        @if (acceptingExpedites) {
          <span [innerHTML]="expeditingMessage"></span>
        } @else {
          <span [innerHTML]="noExpeditingMessage"></span>
        }
      </div>
    }
    <div class="flex progress-wrapper">
      <div class="progress-container text-center flex-item-center">
        <h3 class="white">Progress:</h3>
        @if (haveSections) {
          <span class="section-number-of white">({{currentEditingIndicatorIndex}} of {{sectionsLength}})</span>
        }
      </div>
      <div class="indicators-wrapper flex-item-center">
        <button attr.aria-label="Previous Step" class="indicator-previous" [disabled]="disablePrevious" (click)="incrementProgressBarVisibleIndicator(-1)">
          <span aria-hidden="true">
            <svg-icon icon="icon-chevron-left"></svg-icon>
          </span>
        </button>
        <section class="indicator-container">
          @for (section of sections; track section; let i = $index) {
            <div class="sections-indicators" attr.id="indicator{{i + 1}}" attr.aria-label="Step {{i + 1}}">
              <button (click)="clickSection(section)" [disabled]="(!hasSeenSection(section.id) && i !== 0) || isResuming">
                <section-indicator [number]="i + 1" [text]="section.name" [isActive]="currentPage.section === section.id">
                </section-indicator>
              </button>
            </div>
          }
        </section>
        <button attr.aria-label="Next Step" class="indicator-next" [disabled]="disableNext" (click)="incrementProgressBarVisibleIndicator(1)">
          <span aria-hidden="true">
            <svg-icon icon="icon-chevron-right"></svg-icon>
          </span>
        </button>
      </div>
    </div>
  }
</section>


